const useSecureCookies = process.env.NODE_ENV !== 'development';
const cookiePrefix     = useSecureCookies ? '__Secure-' : '';
const cookieSuffix     = process.env.COOKIE_ENV;
const cookieDomain     = process.env.COOKIE_DOMAIN;

export const authOptionsCookies = {
  sessionToken: {
    name: `${cookiePrefix}next-auth.session-token${cookieSuffix}`,
    options: {
      httpOnly: true,
      sameSite: 'lax',
      path:     '/',
      secure:   useSecureCookies,
      domain:   cookieDomain,
    },
  },
  callbackUrl: {
    name: `${cookiePrefix}next-auth.callback-url${cookieSuffix}`,
    options: {
      httpOnly: true,
      sameSite: 'lax',
      path:     '/',
      secure:   useSecureCookies,
      domain:   cookieDomain,
    },
  },
  csrfToken: {
    name: `_Host-next-auth.csrf-token${cookieSuffix}`,
    options: {
      httpOnly: true,
      sameSite: 'lax',
      path:     '/',
      secure:   useSecureCookies,
      domain:   cookieDomain,
    },
  },
  pkceCodeVerifier: {
    name: `${cookiePrefix}next-auth.pkce.code_verifier${cookieSuffix}`,
    options: {
      httpOnly: true,
      sameSite: 'lax',
      path:     '/',
      secure:   useSecureCookies,
      domain:   cookieDomain,
      maxAge:   900,
    },
  },
  state: {
    name: `${cookiePrefix}next-auth.state${cookieSuffix}`,
    options: {
      httpOnly: true,
      sameSite: 'lax',
      path:     '/',
      secure:   useSecureCookies,
      domain:   cookieDomain,
      maxAge:   900,
    },
  },
  nonce: {
    name: `${cookiePrefix}next-auth.nonce${cookieSuffix}`,
    options: {
      httpOnly: true,
      sameSite: 'lax',
      path:     '/',
      secure:   useSecureCookies,
      domain:   cookieDomain,
    },
  },
}
